import '../../node_modules/focus-visible/dist/focus-visible.js'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider.js'

/** DOMTokenList */
// https://github.com/Alhadis/Fix-IE/edit/master/src/token-list.js
!function(){"use strict";var n,r,t,e,i=window,o=document,u=Object,f=null,a=!0,c=!1,l=" ",s="Element",d="create"+s,h="DOMTokenList",m="__defineGetter__",p="defineProperty",v="class",g="List",y=v+g,w="rel",L=w+g,_="div",b="length",j="contains",S="apply",k="HTML",E=("item "+j+" add remove toggle toString toLocaleString").split(l),A=E[2],C=E[3],M=E[4],N="prototype",O=p in u||m in u[N]||f,T=function(n,r,t,e){u[p]?u[p](n,r,{configurable:c===O?a:!!e,get:t}):n[m](r,t)},x=function(r,t){var e=this,i=[],o={},f=0,s=0,d=function(){if(f>=s)for(;f>s;++s)(function(n){T(e,n,function(){return h(),i[n]},c)})(s)},h=function(){var n,e,u=arguments,c=/\s+/;if(u[b])for(e=0;e<u[b];++e)if(c.test(u[e]))throw n=new SyntaxError('String "'+u[e]+'" '+j+" an invalid character"),n.code=5,n.name="InvalidCharacterError",n;for(i=(""+r[t]).replace(/^\s+|\s+$/g,"").split(c),""===i[0]&&(i=[]),o={},e=0;e<i[b];++e)o[i[e]]=a;f=i[b],d()};return h(),T(e,b,function(){return h(),f}),e[E[6]]=e[E[5]]=function(){return h(),i.join(l)},e.item=function(n){return h(),i[n]},e[j]=function(n){return h(),!!o[n]},e[A]=function(){h[S](e,n=arguments);for(var n,u,c=0,s=n[b];s>c;++c)u=n[c],o[u]||(i.push(u),o[u]=a);f!==i[b]&&(f=i[b]>>>0,r[t]=i.join(l),d())},e[C]=function(){h[S](e,n=arguments);for(var n,u={},c=0,s=[];c<n[b];++c)u[n[c]]=a,delete o[n[c]];for(c=0;c<i[b];++c)u[i[c]]||s.push(i[c]);i=s,f=s[b]>>>0,r[t]=i.join(l),d()},e[M]=function(r,t){return h[S](e,[r]),n!==t?t?(e[A](r),a):(e[C](r),c):o[r]?(e[C](r),c):(e[A](r),a)},function(n,r){if(r)for(var t=0;7>t;++t)r(n,E[t],{enumerable:c})}(e,u[p]),e},D=function(n,r,t){T(n[N],r,function(){var n,e=this,i=m+p+r;if(e[i])return n;if(e[i]=a,c===O){for(var u,f=D.mirror=D.mirror||o[d](_),l=f.childNodes,s=l[b],h=0;s>h;++h)if(l[h]._R===e){u=l[h];break}u||(u=f.appendChild(o[d](_))),n=x.call(u,e,t)}else n=new x(e,t);return T(e,r,function(){return n}),delete e[i],n},a)};if(i[h])r=o[d](_)[y],N=i[h][N],r[A][S](r,E),2>r[b]&&(t=N[A],e=N[C],N[A]=function(){for(var n=0,r=arguments;n<r[b];++n)t.call(this,r[n])},N[C]=function(){for(var n=0,r=arguments;n<r[b];++n)e.call(this,r[n])}),r[M](g,c)&&(N[M]=function(r,t){var e=this;return e[(t=n===t?!e[j](r):t)?A:C](r),!!t});else{if(O)try{T({},"support")}catch(G){O=c}x.polyfill=a,i[h]=x,D(i[s],y,v+"Name"),D(i[k+"Link"+s],L,w),D(i[k+"Anchor"+s],L,w),D(i[k+"Area"+s],L,w)}}();


let doc = document,
    html = doc.documentElement,
    body = doc.body;

// remove "no-script" class
html.className = html.className.replace('no-script', 'script');

// skip link
doc.querySelector('.skip-link').addEventListener('click', function(e) {
  e.preventDefault();
  doc.querySelector(e.target.getAttribute('href')).focus();
});

// toggle buttons
let js_toggles = doc.querySelectorAll('.js-toggle');
if (js_toggles.length) {
  forEach(js_toggles, function(el) {
    let targetStr = el.getAttribute('data-target'),
        target = doc.querySelector(targetStr),
        classStr = el.getAttribute('data-class');

    if (targetStr && target && classStr) {
      el.addEventListener('click', function() {
        target.classList.toggle(classStr);
        el.classList.toggle('expanded');
      });
    }
  })
}

// header sub menu
let header = doc.querySelector('.site-header'),
    mainnavItems = header.querySelectorAll('.mainnav > li'),
    submenuClass = 'subnav-opened',
    activeClass = 'active';
if (header && mainnavItems.length) {
  forEach(mainnavItems, (navItem) => {
    navItem.addEventListener('mouseover', function() {
      if (!header.classList.contains(submenuClass)) { header.classList.add(submenuClass); }
    });
    navItem.addEventListener('mouseout', function() {
      if (header.classList.contains(submenuClass)) { header.classList.remove(submenuClass); }
    });
  });
}

// sliders
let right_arrow = '<svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M13 2l22 22-22 22" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
    thick_arrow = '<svg width="24" height="48" viewBox="0 0 24 48" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M0 0h5l19 24L5 48H0l19-24z"/></svg>',
    arrow_flip = '<svg style="-moz-transform: scaleX(-1); -o-transform: scaleX(-1); -webkit-transform: scaleX(-1); -ms-transform: scaleX(-1); transform: scaleX(-1);"',
    icon_wrapper_left = '<span class="i-arrow"><span class="i-wrapper">',
    icon_wrapper_right = '</span></span>';
let home_headline_slider_el = doc.querySelector('.home-headline-slider');
if (home_headline_slider_el) {
  let home_headline_slider = tns({
    container: home_headline_slider_el,
    mode: 'gallery',
    controlsText: [thick_arrow.replace('<svg', arrow_flip), thick_arrow],
    autoplay: false,
    speed: 600,
    // autoplayHoverPause: true,
    autoplayTimeout: 5000,
    autoplayButtonOutput: false,
    swipeAngel: false,
    responsive: {
      800: {
        autoplay: true
      }
    },
  });
}

// home features
let home_features_el = doc.querySelector('.home-features-slider');
if (home_features_el) {
  let home_features_slider = tns({
    container: home_features_el,
    nav: false,
    loop: false,
    autoHeight: true,
    swipeAngel: false,
    controlsText: [icon_wrapper_left + thick_arrow.replace('<svg', arrow_flip) + icon_wrapper_right,
      icon_wrapper_left + thick_arrow + icon_wrapper_right],
  });
}

// home news
let home_news_el = doc.querySelector('.home-news-slider');
if (home_news_el) {
  let home_news_slider = tns({
    container: home_news_el,
    slideBy: 'page',
    loop: false,
    // autoHeight: true,
    swipeAngel: false,
    gutter: 20,
    controlsText: [icon_wrapper_left + thick_arrow.replace('<svg', arrow_flip) + icon_wrapper_right,
      icon_wrapper_left + thick_arrow + icon_wrapper_right],
    responsive: {
      500: {
        items: 2,
      },
      900: {
        items: 3,
      },
    },
    onInit: function(info) {
      info.container.classList.remove('slider-fallback');
    },
  })
}


function lookupByClass (el, cla) {
  if (el === body) { return null; }
  return typeof el.className !== 'string' || el.className.indexOf(cla) < 0 ? lookupByClass(el.parentNode, cla) : el;
}

function forEach (arr, callback, scope) {
  for (var i = 0, l = arr.length; i < l; i++) {
    callback.call(scope, arr[i], i);
  }
}

// print
// function beforeprint () {
//   if (body.classList.contains('article-page') ||
//       body.classList.contains('static-page') ||
//       body.classList.contains('search-results-page')) {
    
//     let mainClass = doc.querySelector('.full-article') ? '.full-article' : 'main',
//         printStr = 'printlinks',
//         printlinks = doc.querySelector(mainClass+' .'+printStr),
//         baseurl = 'https://www.christianpost.com';
//     if (!printlinks) {
//       let printlinks = doc.createElement('ul'),
//           printlinksStr = '',
//           article = doc.querySelector(mainClass);
//       if (article) {
//         printlinks.className = printStr;
//         let links = doc.querySelectorAll(mainClass+' a:not([href^="mailto:"])'),
//             linkorder = 1;

//         for (var i = 0; i < links.length; i++) {
//           let link = links[i],
//               href = link.getAttribute('href');

//           // if (href !== link.textContent && href !== baseurl && href !== baseurl+'/') {
//           if (href !== link.textContent && !lookupByClass(link, 'pagination')) {
//             if (href.indexOf('http') < 0) {
//               let connectStr = href.charAt(0) === '/' ? '':'/';
//               href = baseurl + connectStr + href;
//             }

//             printlinksStr += '<li>'+linkorder+'. '+href+'</li>';
//             link.insertAdjacentHTML('afterend', '<sup class="link-order"> ('+linkorder+')</sup>');

//             linkorder++;
//           }
//         }

//         printlinks.innerHTML = printlinksStr;
//         article.appendChild(printlinks);
//       }
//     }
//   }
// }

// window.onbeforeprint = beforeprint;